import OpenAI from "openai";
import Cookies from 'js-cookie'

/**
 * Asynchronously transcribes audio using the OpenAI API.
 * 
 * This function takes an audio buffer and a blob, converts them into a File object,
 * and sends the file to the OpenAI API for transcription. The transcribed text is then returned.
 * 
 * @param {ArrayBuffer} buffer - The audio buffer to be transcribed.
 * @param {Blob} blob - The blob containing the audio data.
 * @returns {Promise<string>} - The transcribed text from the API response.
 * @throws Will throw an error if the transcription fails.
 * 
 * @example
 * const audioBuffer = ...; // Audio buffer data
 * const audioBlob = ...; // Audio blob data
 * transcribeAudio(audioBuffer, audioBlob)
 *   .then(transcription => console.log('Transcribed text:', transcription))
 *   .catch(error => console.error('Error:', error));
 */
export async function transcribeAudio(buffer, blob) {
  try {
    const apiKey = Cookies.get('apiKey');
    const openai = new OpenAI({ apiKey, dangerouslyAllowBrowser: true });

    // Create a File object from the buffer with metadata
    const file = new File(buffer, 'audio.mp3', {
      type: blob.type,
      lastModified: Date.now()
    });

    // Perform audio transcription using OpenAI API
    const transcription = await openai.audio.transcriptions.create({
      file: file,
      model: "whisper-1",
    });

    // Return the transcribed text from the API response
    return transcription.text;
  } catch (error) {
    console.error('There was an error transcribing audio:', error);
    throw new Error('There was an error transcribing audio. Check the console logs for more details.');
  }
}
